<div class="sticky">
    <slot></slot>
</div>

<style>
    .sticky {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: rgba(255, 255, 255, 0.4);
        -webkit-backdrop-filter: blur(10px);
        backdrop-filter: blur(10px);
        z-index: 5;
        padding-bottom: 1rem;
        margin-top: -20px;
    }
</style>